export default __webpack_public_path__ + "static/media/blog-img-32.634d1b5c.jpg";